import { Chapter } from '../content/chapters';

const colorMap: Record<Chapter['color'], string> = {
  mint: 'bg-mint/10 text-mint ring-mint/40',
  sky: 'bg-sky/10 text-sky ring-sky/40',
  sun: 'bg-sun/20 text-ink ring-sun',
  coral: 'bg-coral/10 text-coral ring-coral/40',
  violet: 'bg-violet/15 text-violet ring-violet/40',
};

interface Props {
  chapter: Chapter;
  onClick?: () => void;
}

export default function ChapterCard({ chapter, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className={`card p-5 w-full text-left ring-1 transition hover:-translate-y-0.5 ${colorMap[chapter.color]}`}
    >
      <div className="flex items-baseline justify-between mb-2">
        <span className="font-display font-bold text-3xl">{chapter.num}</span>
        <span className="text-xs opacity-70">{chapter.sections.length} sections</span>
      </div>
      <div className="font-display text-lg text-ink">{chapter.title}</div>
    </button>
  );
}
